import type { RouterOutputs } from '@klear/ui/lib/trpc'
import {
  EMPTY_SUPPLIER_FORM as BASE_EMPTY_SUPPLIER_FORM,
  supplierFormToCreateWire,
  supplierFormToUpdateWire,
  supplierReadToForm,
  type SupplierForm,
  type SupplierFormDirty
} from '@klear/supplier/wire.client'

export type SupplierRecord = NonNullable<RouterOutputs['supplier']['get']>

export const EMPTY_SUPPLIER_FORM = BASE_EMPTY_SUPPLIER_FORM

export type SupplierCreateData = ReturnType<typeof supplierFormToCreateWire>
export type SupplierUpdateData = ReturnType<typeof supplierFormToUpdateWire>

export function supplierToFormValues(supplier: SupplierRecord): SupplierForm {
  return supplierReadToForm(supplier)
}

export function formValuesToCreateData(values: SupplierForm): SupplierCreateData {
  return supplierFormToCreateWire(values)
}

export function formValuesToUpdateData(values: SupplierForm, dirty: SupplierFormDirty): SupplierUpdateData {
  return supplierFormToUpdateWire(values, dirty)
}
